import React from 'react'

import { AnimatePresence, motion } from 'framer-motion'
import { useLocation, useOutlet } from 'react-router-dom'

import { Sidebar } from '@/components/ui/Sidebar'
import { useThemeApply } from '@/hooks/useThemeApply'
export default function AppLayout() {
  const location = useLocation()
  const outlet = useOutlet()
  
  useThemeApply()

  return (
    <div className="flex h-screen overflow-hidden transition-colors bg-background text-foreground">

      <Sidebar />

      {/* Main content */}
      <main className="flex-1 overflow-y-auto transition-colors bg-background">
        <AnimatePresence mode="wait">
          {outlet && (
            <motion.div
              key={location.pathname}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.18, ease: 'easeOut' }}
              className="min-h-full"
            >
              {React.cloneElement(outlet, { key: location.pathname })}
            </motion.div>
          )}
        </AnimatePresence>
      </main>
      {/*<ThemePanel />*/}
    </div>
  )
}
